import { render } from "./schoolHome.vue?vue&type=template&id=eaf7a1c6&scoped=true"
import script from "./schoolHome.vue?vue&type=script&lang=js"
export * from "./schoolHome.vue?vue&type=script&lang=js"

import "./schoolHome.vue?vue&type=style&index=0&id=eaf7a1c6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eaf7a1c6"]])

export default __exports__